var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.058 15.47 15.588 1 4.622 11.966a16.467 16.467 0 0 1 11.359 2.802 13.134 13.134 0 0 0 12.335 1.397l1.743-.695zm-3.632 4.692c-4.26.782-8.707-.14-12.341-2.652A13.134 13.134 0 0 0 1.75 16.113l-.75.299L15.588 31l10.839-10.838z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdn);
export default __webpack_public_path__ + "static/media/USDN.75a84c1fdaaf3b90116410d6ced19235.svg";
export { ForwardRef as ReactComponent };